import { AuthProvider, useAuth } from '../context/AuthContext';
import HorizontalList from './HorizontalList';
import IconContainer from './IconContainer';

function Header({title, userId, systemState}) {

    const { user, logout } = useAuth();

    return (
        <>
          {user && (
            <div className="user-info">
              <IconContainer userId={userId} systemState={systemState}></IconContainer>
            </div>
          )}
        </>
    );
};

export default Header;